import axios from "axios";
import { create } from "zustand";

export const useNashr = create((set, get) => ({
    nashrs: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "Nomi",
            dataIndex: "nashriyot",
            key: "nashriyot",
        },
    ],
    ed: {},
    setEd: (ed) => set({ ed }),

    getNashr: () => {
        axios.get("/nashr")
            .then(({ data }) => {
                const nashrs = Array.isArray(data) ? data : [];
                set({ nashrs });
            })
            .catch((err) => {
                console.error('Nashriyotlarni yuklab olishda xatolik:', err);
                set({ nashrs: [] });
            })
    },
    addNashr: (data) => {
        axios.post("/nashr", data)
            .then(() => get().getNashr())
            .catch((err) => {
                console.error('Nashriyot qo\'shishda xatolik:', err);
            })
    },
    editNashr: (data) => {
        axios.put(`/nashr/${data.id}`, data)
            .then(() => get().getNashr())
            .catch((err) => {
                console.error('Nashriyotni taxrirlashda xatolik:', err);
            })
    },
    deleteNashr: (_, id) => {
        axios.delete(`/nashr/${id.id}`)
            .then(() => get().getNashr())
            .catch((err) => {
                console.error('Nashriyotni o\'chirishda xatolik:', err);
            })
    },
}));